import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KanbanFakeGroup } from "~/components/KanbanFakeGroup";
import { KANBAN_NULL_STATE, KANBAN_NULL_STATE_ACTION, KANBAN_NULL_STATE_TEXT } from "~/constants/testIDs";
import { KanbanNullStateColumn } from "./KanbanNullStateColumn";
export const KanbanNullState = (param)=>{
    let { action, text, title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative h-full",
        "data-testid": KANBAN_NULL_STATE,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute inset-x-0 top-[15%] flex flex-col items-center px-8 text-center",
                children: [
                    !!title && /*#__PURE__*/ _jsx("p", {
                        className: "mb-6 text-20 font-medium text-grey-11",
                        children: title
                    }),
                    !!text && /*#__PURE__*/ _jsx("p", {
                        className: "mx-auto mb-8 max-w-screen-sm text-center text-14 font-medium text-grey-10",
                        "data-testid": KANBAN_NULL_STATE_TEXT,
                        children: text
                    }),
                    !!action && /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 flex gap-2",
                        "data-testid": KANBAN_NULL_STATE_ACTION,
                        children: action
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(KanbanFakeGroup, {
                children: [
                    /*#__PURE__*/ _jsx(KanbanNullStateColumn, {}),
                    /*#__PURE__*/ _jsx(KanbanNullStateColumn, {}),
                    /*#__PURE__*/ _jsx(KanbanNullStateColumn, {}),
                    /*#__PURE__*/ _jsx(KanbanNullStateColumn, {}),
                    /*#__PURE__*/ _jsx(KanbanNullStateColumn, {})
                ]
            })
        ]
    });
};
